import type { HttpClient } from '@/lib/http/client.js'
import type { Subscription, SubscriptionPage, SubscriptionSearch } from '@/types/subscription/subscription.type.js'

/** `admin/subscriptions`, read-only, keyset on the numeric id. */
export interface SubscriptionService {
  search: (query: SubscriptionSearch) => Promise<SubscriptionPage>
  get: (id: number) => Promise<Subscription>
}

export function createSubscriptionService(http: HttpClient): SubscriptionService {
  return {
    search: (query) => http.get<SubscriptionPage>('admin/subscriptions', { query: { ...query } }),
    get: (id) => http.get<Subscription>(`admin/subscriptions/${String(id)}`),
  }
}
